"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteral"));
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _react = _interopRequireWildcard(require("react"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _styledIs = _interopRequireDefault(require("../../utils/styled-is"));
var _ArrowDown = _interopRequireDefault(require("@honeybook/icons/dist/icons/ArrowDown16"));
var _HBAccordionNew = _interopRequireDefault(require("../HBAccordionNew/HBAccordionNew"));
var _HBText = _interopRequireDefault(require("../HBText/HBText"));
var _templateObject;
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
var FIXED_VALUE = 'fixed_value';
var HBFormCollapsibleSection = function HBFormCollapsibleSection(_ref) {
  var className = _ref.className,
    defaultOpen = _ref.defaultOpen,
    children = _ref.children,
    title = _ref.title;
  var _useState = (0, _react.useState)(defaultOpen ? FIXED_VALUE : ''),
    _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
    accordionValue = _useState2[0],
    setAccordionValue = _useState2[1];
  var isOpen = accordionValue === FIXED_VALUE;
  return /*#__PURE__*/_react["default"].createElement(_HBAccordionNew["default"].Root, {
    type: "single",
    collapsible: true,
    value: accordionValue,
    onValueChange: setAccordionValue,
    className: className
  }, /*#__PURE__*/_react["default"].createElement(_HBAccordionNew["default"].Item, {
    value: FIXED_VALUE
  }, /*#__PURE__*/_react["default"].createElement(_HBAccordionNew["default"].Trigger, {
    testIdName: 'more-details-block'
  }, /*#__PURE__*/_react["default"].createElement(_HBText["default"], {
    type: "emphasis14"
  }, /*#__PURE__*/_react["default"].createElement("span", null, title), /*#__PURE__*/_react["default"].createElement(StyledArrowDown16, {
    isOpen: isOpen
  }))), /*#__PURE__*/_react["default"].createElement(_HBAccordionNew["default"].Content, null, children)));
};
var _default = exports["default"] = HBFormCollapsibleSection; // -------------------------- Styles -------------------------- //
var StyledArrowDown16 = (0, _styledComponents["default"])(_ArrowDown["default"]).withConfig({
  displayName: "HBFormCollapsibleSection__StyledArrowDown16",
  componentId: "sc-1vsr6ls-0"
})(["display:inline-flex;vertical-align:middle;margin-left:2px;transform:rotate(0deg);", " svg *{fill:currentColor;}"], (0, _styledIs["default"])('isOpen')(_templateObject || (_templateObject = (0, _taggedTemplateLiteral2["default"])(["\n        transform: rotate(-180deg);\n    "]))));
//# sourceMappingURL=HBFormCollapsibleSection.js.map